import React from 'react'
import { useTranslation } from '../../../../i18n'
import { StepWizardChildProps } from 'react-step-wizard'

import SupportEmailForm from '../helpSupportEmailForm'

interface Props {
    onBack: () => void
}

const HelpEmail: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { t } = useTranslation(window.LANG_NS)

    return <SupportEmailForm onBack={props.onBack} />
}

export default HelpEmail
